<template>
  <div
    class="d-flex align-items-center justify-content-center position-relative h-100 w-100 bg-white"
  >
    <div class="content-login">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="position-relative w-100 h-100 text-center mt-2 mb-1">
              <img :src="resolveImage" alt="forgetPasswordImg" width="250" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-1">
            <div class="font-large-1 text-bold text-black text-center">
              {{ titleEn || "Error" }}
            </div>
          </div>
          <div class="col-12 mb-1">
            <div class="font-medium-5 text-black text-center">
              {{ messageEn || "Error" }}
            </div>
          </div>
        </div>
        <div class="row" v-if="button">
          <div class="col">
            <div class="m-3 text-center">
              <div class="w-50 m-auto">
                <b-button
                  class="w-80"
                  type="button"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="onSubmit"
                  ><div class="font-medium-5">{{ buttonText }}</div>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright mt-1 mb-1">
      <img :src="logoChoco" width="150" class="logo-choco" />
    </div>
  </div>
</template>

<script>
import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  ref,
  watch,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import logoChoco from "@/assets/images/logo/logo-choco.png";
import forgetPasswordImg from "@/assets/images/pages/forgor-password/Forgot-link-expire-BP.png";
export default {
  directives: {
    Ripple,
  },
  props: {
    token: { type: String, default: null },
    brandRef: { type: String, default: null },
    image: { type: [Object, String], default: null },
    titleEn: { type: String, default: null },
    titleTh: { type: String, default: null },
    messageEn: { type: String, default: null },
    messageTh: { type: String, default: null },
    button: { type: Boolean, default: null },
    buttonText: { type: String, default: null },
  },
  setup(props, { emit }) {
    const resolveImage = computed(() => {
      if (props?.image) return props?.image;
      return forgetPasswordImg;
    });

    const onSubmit = () => {
      emit("onSubmit");
    };

    return {
      resolveImage,
      onSubmit,
      forgetPasswordImg,
      logoChoco,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>

<style lang="scss" scoped>
@import "~@/assets/css/pages/login/login.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

.content-login {
  background-color: transparent !important;
  box-shadow: none !important;
  width: 700px;
  height: auto;
  display: flex;
  // overflow: hidden;
  z-index: 1;
}
</style>
